module.exports = __webpack_public_path__ + "static/media/Banner_6.2bdd5e92.jpg";